import NotFoundImage from '@/assets/images/not-found.svg'
import { useSocialMediaType } from '@/modules/statistics/social/hooks/use-social-media-type.tsx'

export const NoSocialAccountView = () => {
  const { noSocialAccountsMessage } = useSocialMediaType()

  return (
    <div className="mt-16 grid place-items-center sm:mt-[clamp(200px,15vw,400px)]">
      <NotFoundImage />
      <h4 className="mb-1.5 text-3xl font-semibold text-title">
        No Accounts found
      </h4>
      <p className="max-w-md text-center text-secondary-300">
        {noSocialAccountsMessage}
      </p>
    </div>
  )
}
